/**
 *     ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { TemplateModel } from '../../models';
import { WizardTitleEnum } from '../../enums';

export const GSLBTemplate: TemplateModel = {
    title: 'GSLB (coming soon)',
    version: 1,
    type: 'gslb',
    disabled: true,
    hideMultipleServices: true,
    wizardDefaultMode: 'default',
    wizardModes: ['Default', 'Advanced'],
    description: {
        [WizardTitleEnum.TEMPLATE]: 'Create a GSLB configuration by stepping through this wizard template.'
    },
    sections: {
        [WizardTitleEnum.FRONTENDS]: [
            {
                // General
                domain: {
                    value: '',
                    hidden: false,
                },
                timeToLive: {
                    value: '10',
                    hidden: false
                },
                // Monitors
                monitor: {
                    value: null,
                    hidden: false
                },
                monitorExternalScriptID: {
                    value: null,
                    hidden: false
                },
                monitorInterval: {
                    value: null,
                    hidden: true
                },
                monitorTimeout: {
                    value: null,
                    hidden: true
                },
                monitorRetries: {
                    value: null,
                    hidden: true
                },
                monitorURLPath: {
                    value: null,
                    hidden: false
                },
                monitorPort: {
                    value: null,
                    hidden: false
                },
                monitorExpectedCodes: {
                    value: null,
                    hidden: true
                },
                monitorSendString: {
                    value: null,
                    hidden: false
                },
                monitorMatchRe: {
                    value: null,
                    hidden: false
                },
                monitorStatus: {
                    value: null,
                    hidden: false
                },
                // Other
                lbMethod: {
                    value: null,
                    hidden: false
                }
            }
        ],
        [WizardTitleEnum.BACKENDS]: [
            {
                name: {
                    value: 'test',
                    hidden: false
                },
                ripIds: {
                    value: [],
                    hidden: false
                }
            }
        ],
        // [WizardTitleEnum.TOPOLOGIES]: [
        //     {
        //         title: 'Topology',
        //         subSteps: 1,
        //         ip: {
        //             value: null,
        //             hidden: false,
        //         },
        //         mask: {
        //             value: null,
        //             hidden: false
        //         },
        //         member: {
        //             value: null,
        //             hidden: false
        //         }
        //     }
        // ]
    },
    hiddenSections: {
        [WizardTitleEnum.REALSERVERS]: [
            {
                name: {
                    value: '',
                    hidden: false
                },
                ip: {
                    value: '',
                    hidden: false
                },
                monitorIp: {
                    value: '',
                    hidden: false
                },
                // Regions
                regions: {
                    value: [],
                    hidden: false
                }
            }
        ]
    }
};
